import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

interface ConditionalRouteProps {
  children: React.ReactNode;
}

const ConditionalRoute: React.FC<ConditionalRouteProps> = ({ children }) => {
  const { authState, initializing } = useAuth();

  if (initializing) {
    return null;
  }

  // If not authenticated, redirect to landing page
  if (!authState.isAuthenticated) {
    return <Navigate to="/landing" />;
  }

  // Auth user without a profile document resumes onboarding.
  if (!authState.user && authState.error === "User data not found") {
    return <Navigate to="/onboarding" />;
  }

  // If authenticated, show the children (Dashboard)
  return <>{children}</>;
};

export default ConditionalRoute;
